/**
 * Coerce a value bound to an <input type="number"> into a clean
 * `number | undefined`. Svelte's two-way binding on a numeric input swaps
 * the state value between an empty string, `null`, and a real number depending
 * on what the user has typed and whether they have cleared the field — so a
 * form-state `string` annotation no longer holds once the input is touched.
 * This helper is the single place to normalise that mess at submit time.
 */
export function toScore(value: unknown): number | undefined {
  if (value === null || value === undefined || value === '') return undefined
  const n = typeof value === 'number' ? value : Number(value)
  return Number.isNaN(n) ? undefined : n
}
